
import {
  defineComponent,
} from 'vue';
import { env } from '@/helpers';

export default defineComponent({
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  setup() {
    const showCookieLink = env('UC_ENABLED', false);

    const openUC = (): void => {
      if (window.UC_UI) {
        window.UC_UI.showSecondLayer();
      }
    };

    return {
      showCookieLink,
      openUC,
    };
  },
});
